import { GeometryPriority } from 'components/geometry-priority';
import { PRODUCTION_DATA_SOURCE_LABELS } from 'components/production-source-dropdown';
import type { ProductionDataSource } from 'types/api-responses';

interface ProductionDataSourceHierarchyProps {
  /** The sources in order of preference. */
  sources: ProductionDataSource[];
  /** Called with the sources in their new order. */
  onChange: (sources: ProductionDataSource[]) => void;
}

/**
 * Drag-to-reorder list of production data sources for a DCA general config.
 * Shows each source by its user-facing name.
 *
 * @param {ProductionDataSourceHierarchyProps} props - The sources and the change handler.
 * @return {JSX.Element} The ranked list.
 */
export function ProductionDataSourceHierarchy({
  sources,
  onChange,
}: ProductionDataSourceHierarchyProps): JSX.Element {
  const sourceByLabel = Object.fromEntries(
    sources.map((source) => [PRODUCTION_DATA_SOURCE_LABELS[source], source])
  );

  return (
    <GeometryPriority
      label="Production Data Source Hierarchy"
      description="A well's production comes from the highest-ranked source that has data for it."
      items={sources.map((source) => PRODUCTION_DATA_SOURCE_LABELS[source])}
      onChange={(labels) =>
        onChange(labels.map((label) => sourceByLabel[label]))
      }
    />
  );
}
